// Clinic configuration values. Replace the placeholder place ID with the actual Google Maps Place ID.
// Retrieve the Place ID using the Google Place ID Finder tool: https://developers.google.com/maps/documentation/javascript/examples/places-placeid-finder
// Example Place ID format: ChIJxxxxxxxxxxxxxxxxx
export const CLINIC_PLACE_ID = 'PLACE_ID_REPLACE';
// Fallback coordinates (lat, lng) extracted from the embed URL
export const CLINIC_LAT = 20.339908;
export const CLINIC_LNG = 85.822081;
